<template>
  <div
    class="banner_base"
    :class="{detail_show: showDetail}"
  >
    <div
      :class="['product-banner', {'active': isActive}, {'multi': imageCount > 1}]"
      :style="{ ...dotsStyleVariables, '--animation-duration': `${animationDuration}ms` }"
    >
      <!-- <PrevButton
        v-if="nextImage"
        class="btn prev"
        @handlePrevBtnClick="showPrevImage"
      /> -->
      <div class="image_area">
        <div
          class="image"
        >
          <img
            class="current"
            :src="currentImage"
            @animationend="setCurrentImageIndex(animationDelay)"
          />
          <img
            class="next"
            :src="nextImage"
          />
        </div>
        <!-- <div class="point_area">
          <div class="pack_point" v-if="!showDetail">{{packItem.point | comma}} P</div>
        </div> -->
        <div v-if="showDetail" class="sp_pack_title">
          <span>{{packItem.name}}</span>
          <span class="red_message">{{t('残数')}}
            {{packItem.pack_count | comma}}{{t('パック')}}
          </span>
        </div>
      </div>
      <div
        v-if="nextImage"
        class="image next"
        :style="{backgroundImage: `url(${nextImage})`}"
      />
      <!-- <NextButton
        v-if="nextImage || false"
        class="btn next"
        @handleNextBtnClick="showNextImage"
      /> -->

      <!-- <div v-if="nextImage" class="dots" ref="dots">
        <div
          v-for="item in imageCount"
          :key="item"
          :class="['dot', {'active': item - 1 === currentImageIndex}]"
          @click="showSelectImage(item - 1)"
        />
      </div> -->

    </div>
    <!-- <div class="pack_name">{{packItem.name}}</div> -->
    <!-- <LeafBox class="pack_area" :areaCenter="true"  v-if="!showDetail">
      <div class="pack_name">{{packItem.name}}</div>
    </LeafBox> -->
    <div class="button_area" v-if="!showDetail">
      <!-- <span v-if="currentUser.is_login == '0'">
        <BlackGradationButton
          class="square-button"
          text="ログインする"
          @handleSquareBtnClick="handleLoginClick()"
        />
      </span>-->
      <span>
        <div class="name_area">
          <div>{{packItem.name}}</div>
          <!-- <div>{{t('1回')}}{{packItem.point | comma}}P/{{t('全')}}{{packItem.total_pack_count | comma}}{{t('回')}}</div> -->
          <div class="zan" v-if="packItem.pack_count > 0 && !isCountdown">
            {{t('残り')}}{{packItem.pack_count | comma}}{{t('パック')}}
          </div>
          <div class="button_detail">
            <RoundButton @handleRoundBtnClick="handleShowDetail(packItem)">{{t('ガチャ詳細へ')}}</RoundButton>
          </div>
        </div>
        <div class="countdown" v-if="isCountdown">
          <div class="c_back">
            <span class="label_title">{{t('販売開始まで')}}</span>
            <span class="num">{{countdownStr}}</span>
          </div>
        </div>
        <div class="sold_out" v-if="packItem.pack_count == 0"><span>Sold out</span></div>
        <!-- <BlackGradationButton
          v-if="packItem.pack_count > 0 && !isCountdown"
          class="square-button"
          text="購入する"
          @handleSquareBtnClick="handleBannerClick(packItem.id)"
        /> -->
      </span>
    </div>
  </div>
</template>

<script>
import {
  separateCharacterNumber,
} from '@/common/util/format';
import RoundButton from '@/components/atoms/RoundButton.vue';
// import PrevButton from '@/components/molecules/PrevButton.vue';
// import NextButton from '@/components/molecules/NextButton.vue';
// import LeafBox from '@/components/organisms/LeafBox.vue';
// import BlackGradationButton from '@/components/atoms/BlackGradationButton.vue';
import t from '@/plugins/i18n';

export default {
  name: 'ProductBanner',

  components: {
    RoundButton,
    // PrevButton,
    // NextButton,
    // LeafBox,
    // BlackGradationButton,
  },
  mixins: [t],

  filters: {
    comma(value) {
      return separateCharacterNumber(value);
    },
  },

  props: {
    packItem: {
      type: Object,
      default: () => {},
    },
    showDetail: {
      type: Boolean,
      default: false,
    },
    currentUser: {
      type: Object,
    },
  },

  data: () => ({
    currentImageIndex: null,
    nextImageIndex: null,
    isActive: false,
    animationDelay: 2000,
    animationDuration: 1000,
    timer: null,
    isCountdown: false,
    countdownStr: '',
    setTimerID: null,
  }),

  computed: {
    currentImage() {
      if (this.packItem && this.packItem.image && this.currentImageIndex !== null) {
        return this.packItem.image[this.currentImageIndex];
      }
      return null;
    },
    nextImage() {
      if (this.packItem && this.packItem.image && this.nextImageIndex !== null) {
        return this.packItem.image[this.nextImageIndex];
      }
      return null;
    },
    imageCount() {
      if (this.packItem && this.packItem.image) {
        return this.packItem.image.length;
      }
      return 0;
    },
    dotsStyleVariables() {
      if (this.imageCount > 0) {
        const dotWidth = 7;
        const dotHeight = 7;
        const dotMargin = 10;
        const dotsWidth = this.imageCount * (dotWidth + dotMargin) - dotMargin;
        return {
          '--dot-width': `${dotWidth}px`,
          '--dot-height': `${dotHeight}px`,
          '--dot-margin': `${dotMargin}px`,
          '--dots-width': `${dotsWidth}px`,
        };
      }
      return null;
    },
  },

  mounted() {
    this.$nextTick(() => {
      if ('image' in this.packItem) {
        this.currentImageIndex = 0;
        // 画像が2枚以上ある場合、次の画像indexをセットする。
        if (this.packItem.image.length > 1) {
          this.setNextImageIndex();
        }
      }
    });

    // const day1 = new Date(this.packItem.start_date);
    // const day2 = new Date();
    // const diffDay = day1 - day2;
    if (this.packItem.is_before) {
      this.isCountdown = true;
      this.setTimerID = setInterval(() => {
        this.setCountdownString();
      }, 1000);
      this.setCountdownString();
    }
  },

  methods: {
    setCountdownString() {
      const day1 = new Date(this.packItem.start_date.replace(/-/g, '/'));
      const day2 = new Date();
      const diffDay = day1 - day2;
      if (diffDay < 0) {
        this.isCountdown = false;
        clearInterval(this.setTimerID);
        return;
      }
      const h = `0${parseInt(diffDay / (1000 * 60 * 60), 10)}`.slice(-2);
      const m = `0${parseInt((diffDay % (1000 * 60 * 60)) / (1000 * 60), 10)}`.slice(-2);
      const s = `0${parseInt((diffDay % (1000 * 60)) / (1000), 10)}`.slice(-2);
      // const ms = `00${parseInt((diffDay % 1000), 10)}`.slice(-3);
      // this.countdownStr = `${h}.${m}.${s}.${ms}`;
      this.countdownStr = `${h}.${m}.${s}`;
    },
    handleBannerClick(packId) {
      this.$emit('handleBannerClick', (packId));
    },
    handleLoginClick() {
      this.$emit('handleLoginClick');
    },
    setCurrentImageIndex(animationDelay = this.animationDelay, imageIndex = null) {
      // imageIndexが明示的に渡された時は渡された値にimageIndexを変更する
      if (imageIndex !== null) {
        this.currentImageIndex = imageIndex;
      } else if (imageIndex === null && this.currentImageIndex === this.imageCount - 1) {
        // if (this.currentImageIndex === this.imageCount - 1) {
        this.currentImageIndex = 0;
      } else {
        this.currentImageIndex += 1;
      }
      setTimeout(() => {
        this.changeIsActive(false);
        // this.isActiveがfalseになり画面が際レンダリングされてから呼び出す。
        this.$nextTick(() => {
          this.setNextImageIndex(animationDelay);
        });
      }, 500);
    },
    setNextImageIndex(animationDelay = this.animationDelay) {
      // アニメーションを開始する
      this.timer = setTimeout(() => {
        this.changeIsActive(true);
      }, animationDelay);
      // 現在の画像が配列の末尾のものの場合
      if (this.currentImageIndex === this.imageCount - 1) {
        this.nextImageIndex = 0;
      } else {
        this.nextImageIndex = this.currentImageIndex + 1;
      }
    },
    changeIsActive(status) {
      this.isActive = status;
    },
    showPrevImage() {
      // アニメーション中は何もしない
      if (this.isActive) {
        return;
      }
      if (this.timer) {
        clearTimeout(this.timer);
      }
      if (this.currentImageIndex === 0) {
        this.currentImageIndex = this.imageCount - 1;
      } else {
        this.currentImageIndex -= 1;
      }
      this.changeIsActive(false);
      // this.isActiveがfalseになり画面が際レンダリングされてから呼び出す。
      this.$nextTick(() => {
        this.setNextImageIndex(this.animationDelay);
      });
    },
    showNextImage() {
      // アニメーション中は何もしない
      if (this.isActive) {
        return;
      }
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.setCurrentImageIndex(this.animationDelay);
    },
    showSelectImage(imageIndex) {
      // アニメーション中は何もしない
      if (this.isActive) {
        return;
      }
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.setCurrentImageIndex(this.animationDelay, imageIndex);
    },
    handleShowDetail(packItem) {
      // if (this.isCountdown) {
      //   return;
      // }
      if (packItem.pack_count === 0) {
        return;
      }
      if (packItem.pack_count === '0') {
        return;
      }
      // if (this.currentUser.is_login === '0') {
      //   this.handleLoginClick();
      // } else if (packItem.pack_count > 0) {
      this.handleBannerClick(packItem.id);
      // }
    },
  },

};
</script>

<style lang="scss" scoped>
$shadowBtnHeight: 77px;

.banner_base {
  margin: 0 10px;
  width: 285px;
  min-width: 285px;
  border: solid 1px #eee;
  border-radius: 8px;
  box-shadow: $bannerShadow;
  position: relative;
}

.detail_show {
  width: 100%;
}

.product-banner{
  width: 100%;
  .image{
    position: relative;
    width: 100%;
    .current{
      opacity: 1;
    }
    .next{
      opacity: 0;
      position: absolute;
      top: 0;
      left: 0;
    }
    img {
      width: 100%;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
    }
  }
  .btn{
    position: absolute;
    height: $shadowBtnHeight;
    top: calc(50% - #{$shadowBtnHeight}/2);
    z-index: 1;
    cursor: pointer;
    &.prev{
      left: 8px;
    }
    &.next{
      right: 4px;
    }
  }
  .dots{
    position: absolute;
    left: calc(50% - (var(--dots-width) / 2));
    bottom: -21px;
    display: flex;
    .dot{
      width: var(--dot-width);
      height: var(--dot-height);
      background-color: $white;
      border-radius: 100%;
      border: solid 1px $yellow;
      & + .dot{
        margin-left: var(--dot-margin);
      }
      &.active{
        background: $yellow;
      }
    }
  }
  &.active{
    .image{
      .current{
        animation-name: fadeOut;
        animation-duration: var(--animation-duration);
        animation-timing-function: ease-in;
        animation-delay: 0s;
        animation-iteration-count: 1;
        animation-direction: normal;
        animation-fill-mode: forwards;
      }
      .next{
        animation-name: fadeIn;
        animation-duration: var(--animation-duration);
        animation-timing-function: ease-in;
        animation-delay: 0s;
        animation-iteration-count: 1;
        animation-direction: normal;
        animation-fill-mode: forwards;
      }
    }
  }
  &.multi {
    margin-bottom: 15px;
  }

  .point_area {
    .pack_point {
      position: absolute;
      top: 10px;
      left: 10px;
      background-color: #000;
      border-radius: 100px;
      color: $white;
      padding: 4px 10px;
      min-width: 90px;
      text-align: center;
      z-index: 1;
    }
  }
}
.pack_area {
  margin-top: 30px;
  .pack_name {
    margin-bottom: -15px;
  }
}
.pack_name {
  margin-top: 10px;
  color: $white;
  font-size: 16px;
  font-weight: bold;
}
.sold_out {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding-bottom: 0%;
  background-color: rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  color: $red;
  font-size: 34px;
  border-radius: 8px;
  span{
    border-radius: 8px;
    background-color: $white;
    padding: 5px 20px;
    font-weight: bold;
  }
}
.countdown {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding-bottom: 0%;
  background-color: rgba(255, 255, 255, 0.7);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  .c_back {
    text-align: center;
    margin: 0 20px;
    margin-top: -120px;
    span.num {
      color: #FF8C00;
      background: $mainColor;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      font-size: 36px;
      font-family: seven-segment!important;
    }
    span.label_title {
      font-size: 12px;
      font-weight: bold;
      margin-bottom: 10px;
      color: $black;
    }
  }
}
.button_area {
  color: $black;
  padding: 0 0 10px 0;
  font-size: 22px;
  .name_area {
    text-align: center;
    .zan {
      font-size: 18px;
    }
  }
  .button_detail {
    margin-top: 10px;
  }
}
.sp_pack_title {
  display: none;
}

@media screen and (max-width: $tabletWidth) {
  .banner_base {
    margin: 0 auto;
    width: 60vw;
    min-width: 60vw;
  }
  .countdown {
    font-size: 18px;
    flex-direction: column;
    .c_back {
      span.num {
        font-size: 24px;
      }
    }
  }
  .sold_out {
    font-size: 18px;
  }
  .name_area {
    font-size: 80%;
    .zan {
      font-size: 70%!important;
    }
  }
  .sp_pack_title {
    display: flex;
    flex-direction: column;
    text-align: center;
    height: 96px;
    font-size: 22px;
    .red_message {
      font-size: 18px;
      margin-top: 5px;
    }
  }
}

@font-face {
  font-family: seven-segment;
  src: url(/fonts/LED7SEG_Standard.ttf)
  format('TrueType')
}
</style>
